import req from '../../api/request'
import type { EventPayload, SnEvent } from '../../features/event/types'

/** Create an event under a team's roster. */
export const createEvent = async (
  teamId: string,
  rosterId: string,
  payload: EventPayload
): Promise<SnEvent> => {
  const response = await req(`/teams/${teamId}/rosters/${rosterId}/events`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return response.data as SnEvent
}
